/* tslint:disable */
/* eslint-disable */
/**
 * My API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface EntityAuditHistoryDto
 */
export interface EntityAuditHistoryDto {
    /**
     * 
     * @type {string}
     * @memberof EntityAuditHistoryDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityAuditHistoryDto
     */
    'action'?: EntityAuditHistoryDtoActionEnum;
    /**
     * 
     * @type {object}
     * @memberof EntityAuditHistoryDto
     */
    'dataSourceOptions'?: object;
    /**
     * 
     * @type {string}
     * @memberof EntityAuditHistoryDto
     */
    'entityId'?: string;
    /**
     * 
     * @type {number}
     * @memberof EntityAuditHistoryDto
     */
    'created'?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityAuditHistoryDto
     */
    'creator'?: string;
}

export const EntityAuditHistoryDtoActionEnum = {
    Edit: 'EDIT',
    Create: 'CREATE',
    Reload: 'RELOAD',
    Append: 'APPEND'
} as const;

export type EntityAuditHistoryDtoActionEnum = typeof EntityAuditHistoryDtoActionEnum[keyof typeof EntityAuditHistoryDtoActionEnum];


